import React, { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

function AllFeaturesIntegrationSection() {
  const allFeaturesList = [
    "Zero Pay Checkout",
    `“1-click” Express & Biometric Checkout`,
    "Customizable period for payment capturing",
    "Direct Debit and Account to Account payments (coming soon)",
    "Logistics integration including reverse logistics support",
    "Fraud detection, analysis and upto 99% Fraud prevention",
    "Scheduled Payment Links & QR Codes",
    "Multiple Payment Methods and Bank Instalments",
  ];

  const sectionRef = useRef(null);
  const textSectionRef = useRef(null);
  const featuresListRef = useRef(null);

  useGSAP(() => {
    gsap.fromTo(
      sectionRef.current,
      { y: 100, opacity: 0, scale: 1 },
      {
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 90%",
          end: "top 85%",
          scrub: false,
          toggleActions: "play none none reverse",
        },
        y: 0,
        opacity: 1,
        duration: 1,
        scale: 1,
        ease: "sine.out",
      }
    );

    gsap.fromTo(
      textSectionRef.current,
      { y: 50, opacity: 0 },
      {
        scrollTrigger: {
          trigger: textSectionRef.current,
          start: "top 80%",
          end: "top 75%",
          scrub: false,
          toggleActions: "play none none reverse",
        },
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "sine.out",
      }
    );

    gsap.fromTo(
      featuresListRef.current,
      { y: 50, opacity: 0 },
      {
        scrollTrigger: {
          trigger: featuresListRef.current,
          start: "top 78%",
          end: "top 74%",
          scrub: false,
          toggleActions: "play none none reverse",
        },
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "sine.out",
      }
    );
  });

  return (
    <section
      ref={sectionRef}
      className="relative transition-all ease-out mt-16 xl:mt-52 mx-5 sm:mx-auto p-6 xl:p-10 xl:w-full max-w-[633px] xl:max-w-[1280px] 2xl:max-w-[1440px] border-4 border-black rounded-[30px] flex flex-col xl:flex-row items-start shadow-[6px_6px_0_black]"
    >
      <section
        ref={textSectionRef}
        className="pt-7 xl:pt-[90px] w-full xl:w-[758px] xl:min-w-[757px]"
      >
        <h2 className="text-base sm:text-[22px] xl:text-[46px] font-HalvarBreitMedium text-[#100C08] leading-[30px] sm:leading-[44px] xl:leading-[64px] -tracking-[2%] text-center xl:text-left">
          <span className="text-[27px] sm:text-[42px] xl:text-[52px] font-HalvarBreitBold text-[#100C08] leading-[42px] sm:leading-[42px] xl:leading-[64px] -tracking-[2%] xl:-tracking-[1.04px]">
            All These Features –
          </span>
          <br />
          In just one{" "}
          <span className="inline-flex flex-col line-through relative after:content-['simple'] after:font-HalvarBreitBold xl:after:font-HalvarBreitMedium after:absolute after:top-[80%] sm:after:top-[60%] xl:after:top-full after:-rotate-[6deg]">
            single
          </span>{" "}
          integration
        </h2>
        <button
          className="hidden xl:block mt-8 text-lg font-gtAmericaMedium text-center uppercase leading-[21.69px] text-white bg-[#100C08] border border-black rounded w-fit pb-3 pt-3.5 px-6 "
          onClick={() => {
            window.open("https://forms.fillout.com/t/gM3KTnEim2us", "_blank");
          }}
        >
          BOOK A DEMO
        </button>
      </section>
      <svg
        width="338"
        height="193"
        viewBox="0 0 338 193"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute -bottom-[24px] xl:bottom-0 -left-[15px] xl:left-0 scale-75 xl:scale-100 w-[120px] xl:w-[313px]"
      >
        <path
          d="M275.215 365.63C275.215 365.63 250.726 361.683 233.086 379.841C215.445 398 219.943 422.489 219.943 422.489C222.864 467.593 167.679 491.307 137.116 458.133C137.116 458.133 122.323 437.957 97.3229 438.264C72.3228 438.571 58.0266 459.113 58.0266 459.113C28.2952 493.018 -27.3854 470.649 -25.6331 425.486C-25.6331 425.486 -21.997 366.156 -76.2028 369.621L-82.2338 370.002C-127.138 372.926 -150.765 317.514 -117.733 286.826C-117.733 286.826 -97.6544 271.519 -97.9464 246.854C-98.2531 221.999 -118.697 207.379 -118.697 207.379C-152.43 177.539 -130.175 121.615 -85.2127 123.37C-85.2127 123.37 -60.753 127.332 -43.0835 109.159C-25.2096 90.7517 -29.9409 66.5257 -29.9409 66.5111C-32.8615 21.4218 22.3227 -2.30718 52.8864 30.8665C52.8864 30.8665 67.6791 51.0427 92.6792 50.7357C117.679 50.4287 131.946 29.887 131.946 29.887C161.678 -4.01776 217.358 18.3515 215.606 63.5139C215.606 63.5139 211.649 88.0762 229.756 105.825C247.864 123.575 272.207 118.984 272.207 118.984C317.125 116.06 340.738 171.471 307.706 202.159C307.706 202.159 287.613 216.634 287.919 242.132C288.226 266.986 308.67 281.607 308.67 281.607C342.446 311.476 320.177 367.385 275.215 365.63Z"
          stroke="#FFC644"
          strokeWidth="25"
          strokeMiterlimit="10"
        />
      </svg>

      {/* list */}
      <section
        ref={featuresListRef}
        className="py-[50px] pl-0 xl:pl-5 2xl:pl-[60px] xl:max-w-[630px]"
      >
        <ul className="flex sm:grid grid-cols-2 grid-rows-4 grid-flow-row-dense xl:flex flex-col gap-5">
          {allFeaturesList.map((feature, index) => {
            return (
              <li
                key={index}
                className={`text-sm xl:text-lg font-HalvarBreitMedium text-black leading-[16.24px] xl:leading-[28px] flex items-center gap-2.5 ${
                  index < allFeaturesList.length / 2
                    ? "col-start-1"
                    : "col-start-2"
                }`}
              >
                <div className="border-[1.5px] border-black w-[20px] xl:w-[30px] min-w-[20px] xl:min-w-[30px] h-[20px] xl:h-[30px] aspect-square rounded-full flex items-center justify-center bg-[#9B03D0] shadow-[1px_1px_0_black]">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.9999 10L4.9999 7.77502C4.9999 5.01668 6.95824 3.88335 9.3499 5.26668L11.2749 6.38335L13.1999 7.50002C15.5916 8.88335 15.5916 11.1417 13.1999 12.525L11.2749 13.6417L9.3499 14.7584C6.95824 16.1417 4.9999 15.0084 4.9999 12.25L4.9999 10Z"
                      fill="white"
                      stroke="#100C08"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                {feature}
              </li>
            );
          })}
        </ul>
      </section>

      <button
        className="z-[2] block xl:hidden mx-auto mt-2 text-lg font-gtAmericaMedium text-center uppercase leading-[21.69px] text-white bg-[#100C08] border border-black rounded w-fit pb-3 pt-3.5 px-6 "
        onClick={() => {
          window.open("https://forms.fillout.com/t/gM3KTnEim2us", "_blank");
        }}
      >
        BOOK A DEMO
      </button>
    </section>
  );
}

export default AllFeaturesIntegrationSection;
